"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Toggleable = _interopRequireDefault(require("../../../darkmatter/Toggleable"));

var _MobileLink = _interopRequireDefault(require("./MobileLink"));

var _MobileDropddownMenuitems = _interopRequireDefault(require("./MobileDropddownMenuitems"));

var _default = function _default(_ref) {
  var logo = _ref.logo,
      position = _ref.position,
      links = _ref.links,
      linksAs = _ref.linksAs,
      className = _ref.className,
      centerMobileNavItems = _ref.centerMobileNavItems,
      backgroundColor = _ref.backgroundColor,
      internalLinkComponent = _ref.internalLinkComponent,
      invertedHamburgerButton = _ref.invertedHamburgerButton;
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Segment, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_Toggleable["default"], null, function (toggle, onToggle) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        textAlign: 'center',
        position: 'relative',
        verticalAlign: 'middle',
        margin: '0.5em 0'
      }
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
      onClick: onToggle,
      style: {
        padding: 0,
        background: 'none',
        display: 'inline-block',
        "float": position === 'left' ? 'right' : 'left',
        textAlign: 'center',
        height: '40px',
        width: '40px'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
      inverted: invertedHamburgerButton,
      name: "bars",
      size: "large",
      color: backgroundColor === 'primary' || backgroundColor === 'secondary' ? 'primary' : 'primary',
      style: {
        margin: '0 auto',
        height: 'unset'
      }
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        margin: '0 40px',
        height: '40px',
        verticalAlign: 'middle',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, logo)), toggle && /*#__PURE__*/_react["default"].createElement("div", null, links.map(function (_ref2) {
      var slug = _ref2.slug,
          pageTitle = _ref2.pageTitle,
          internal = _ref2.internal,
          as = _ref2.as,
          className = _ref2.className,
          disableToggle = _ref2.disableToggle,
          dropdown = _ref2.dropdown;

      if (dropdown) {
        return /*#__PURE__*/_react["default"].createElement(_MobileDropddownMenuitems["default"], {
          title: dropdown.title,
          options: dropdown.options,
          linksAs: linksAs,
          internalLinkComponent: internalLinkComponent
        });
      }

      return /*#__PURE__*/_react["default"].createElement(_MobileLink["default"], {
        internalLinkComponent: internalLinkComponent,
        centerMobileNavItems: centerMobileNavItems,
        linksAs: linksAs,
        slug: slug,
        pageTitle: pageTitle,
        onToggle: onToggle,
        internal: internal,
        linkComponent: as,
        backgroundColor: backgroundColor,
        className: className,
        disableToggle: !!disableToggle
      });
    })));
  }));
};

exports["default"] = _default;